import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ChevronHollowLeft = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M20 2.00002C22.206 2.00002 24 3.79402 24 6.00002C24 7.06802 23.584 8.07302 22.828 8.82802L15.656 16L22.828 23.172C23.584 23.928 24 24.932 24 26C24 28.206 22.206 30 20 30C18.932 30 17.927 29.584 17.172 28.828L7.17198 18.828C6.41698 18.072 6.00098 17.068 6.00098 15.999C6.00098 14.93 6.41698 13.926 7.17198 13.17L17.172 3.17002C17.928 2.41402 18.932 1.99902 20.001 1.99902L20 2.00002ZM20 28C21.103 28 22 27.103 22 26C22 25.466 21.792 24.964 21.414 24.586L13.535 16.708C13.145 16.317 13.145 15.684 13.535 15.294L21.414 7.41502C21.792 7.03702 22 6.53502 22 6.00102C22 4.89802 21.103 4.00102 20 4.00102C19.466 4.00102 18.964 4.20902 18.586 4.58702L8.58598 14.587C8.20798 14.965 7.99998 15.467 7.99998 16.001C7.99998 16.535 8.20798 17.038 8.58598 17.415L18.586 27.415C18.964 27.793 19.466 28.001 20 28.001V28Z" />
	</svg>
);

export default ChevronHollowLeft;
